const constants = {
    // keys
    tokenKey: 'tokenUserSession',
    id: 'userid',
    role: 'role',
};

export default constants;
